import { render, staticRenderFns } from "./ValidationMessages.vue?vue&type=template&id=ee06f602"
import script from "./ValidationMessages.vue?vue&type=script&lang=js"
export * from "./ValidationMessages.vue?vue&type=script&lang=js"
import style0 from "./ValidationMessages.vue?vue&type=style&index=0&id=ee06f602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../acquisition-home/node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports